/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_TimezoneInputs */

const en_reference_field_timezone = /** @type {(inputs: Reference_Field_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time zone`)
};

/**
* | output |
* | --- |
* | "Time zone" |
*
* @param {Reference_Field_TimezoneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_timezone = /** @type {((inputs?: Reference_Field_TimezoneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_TimezoneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_timezone(inputs)
});